let currencyFilterMixin = {
	filters: {
		currency: function (value) {
			if (!value || isNaN(parseFloat(value))) {
				return "$0.00"
			}
			return "$" + parseFloat(value).toFixed(2)
		}
	}
}

export default currencyFilterMixin
